const tr = {
  app_name: 'Polatlar Mobilya',
  dashboard: 'Dashboard',
  customers: 'Müşteriler',
  sales: 'Satışlar',
  payments: 'Ödemeler',
  stock: 'Stok / Ürünler',
  deliveries: 'Teslimatlar',
  reports: 'Ciro & Raporlar',
  expenses: 'Giderler',
  cash: 'Kasa',
  settings: 'Ayarlar',
  daily_revenue: 'Bugünkü Ciro',
  monthly_revenue: 'Aylık Ciro',
  total_receivable: 'Toplam Alacak',
  overdue_amount: 'Geciken Ödeme',
  total_customers: 'Toplam Müşteri',
  stock_count: 'Stoktaki Ürün',
  today_deliveries: 'Bugünkü Teslimat',
  monthly_sales: 'Bu Ay Satış',
  recent_sales: 'Son Satışlar',
  upcoming_payments: 'Yaklaşan Ödemeler',
  overdue_payments: 'Gecikmiş Ödemeler',
  critical_stock: 'Kritik Stok Uyarıları',
  top_products: 'En Çok Satan Ürünler',
  sales_distribution: 'Satış Dağılımı',
  monthly_revenue_chart: 'Aylık Ciro Grafiği',
  view_all: 'Tümünü Gör',
  quick_action: 'Hızlı İşlem',
  new_sale: 'Yeni Satış',
  new_customer: 'Yeni Müşteri',
  receive_payment: 'Ödeme Al',
  search: 'Ara...',
  profile: 'Profil',
  logout: 'Çıkış Yap',
  overview: 'İşletme genel durum özeti',
  compared_to_last_month: 'geçen aya göre',
  coming_soon: 'Bu sayfa yakında eklenecek',
};

export default tr;